import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../shared";
import { ExternalGenDocLineItnDocLineMatchingBalanceContainerModel } from "../../../../../../models/aggregates/generic_doc/external-gen-doc-line-itn-matching-balance-container.model";

//https://api.akaun.cloud/core2/tnt/dm/erp/xtn/gen-doc/xtn-line-to-itn-line-matching-balances/backoffice-ep

@Injectable({ providedIn: "root" })
export class ExternalGenDocLineItnDocLineMatchingService extends BaseApiTemplateService<ExternalGenDocLineItnDocLineMatchingBalanceContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + Core2Config.EXTERNAL_PREFIX + Core2Config.GENERIC_PREFIX + "xtn-line-to-itn-line-matching-balances/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + Core2Config.EXTERNAL_PREFIX + Core2Config.GENERIC_PREFIX + "xtn-line-to-itn-line-matching-balances/backoffice-ep";
    this.httpClient = http;
  }
}
